import name from './name'
import { REFERRAL_REQUEST_STATUS } from './slice'

const selectSliceData = state => state[name]

const selectReferralRequestStatus = state => selectSliceData(state)?.requestStatus || REFERRAL_REQUEST_STATUS.idle

const selectReferralStatus = state => selectSliceData(state)?.status || 'hidden'

const selectReferral = state => selectSliceData(state)?.referral || null

// The request has come back, one way or the other
const selectReferralSettled = state => {
  const requestStatus = selectReferralRequestStatus(state)
  return requestStatus === REFERRAL_REQUEST_STATUS.ready || requestStatus === REFERRAL_REQUEST_STATUS.error
}

export { selectReferralRequestStatus, selectReferralStatus, selectReferral, selectReferralSettled }
